module.exports = __webpack_public_path__ + "img/3.99629398.png";